import { render } from "./InquiryLayout.vue?vue&type=template&id=681064de"
import script from "./InquiryLayout.vue?vue&type=script&lang=js"
export * from "./InquiryLayout.vue?vue&type=script&lang=js"

import "./InquiryLayout.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__